export const EmailTableCellName = {
  Activities: 'activities',
  Contractors: 'contractors',
  Created: 'created',
  ExternalContacts: 'external_contacts',
  Inhabitants: 'inhabitants',
  LastMessageCreated: 'last_message_created',
  LinkedRequests: 'linked_requests',
  Participants: 'participants',
  StaffMembers: 'staff_members',
  Subject: 'subject',
  Updated: 'updated',
  UpdatedBy: 'updated_by',
}

export const EmailSubMenuParam = {
  Archive: 'archive',
  Important: 'important',
  Inbox: 'inbox',
  Sent: 'sent',
  Trash: 'trash',
}
